import { apiRouter, axiosGet, axiosPost } from '../../services';
import { dispatch } from '../store';

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  isLoading: false,
  error: null,
  users: [],
  user: {},
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET Users
    getUsersSuccess(state, action) {
      state.isLoading = false;
      state.users = action.payload;
    },

    // GET User
    getUserSuccess(state, action) {
      state.isLoading = false;
      state.user = action.payload;
    },
  },
});

export default slice.reducer;

export function getUsers() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosGet(apiRouter.GET_ALL_USERS);
      console.log('response :>> ', response);
      const { success, msg, data } = response;
      if (success) {
        dispatch(slice.actions.getUsersSuccess(data));
      } else {
        dispatch(slice.actions.hasError(message || 'something went wrong'));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
